import React, { useState, useEffect, useContext } from 'react';
import {
 Button,
 Menu,
 MenuItem,
 Divider,
 Typography,
 Box,
 ListItemText,
 ListItemIcon,
 Chip,
} from '@mui/material';
import {
 Folder as FolderIcon,
 Save as SaveIcon,
 Settings as SettingsIcon,
 KeyboardArrowDown as ArrowDownIcon,
} from '@mui/icons-material';
import { ReportTemplateService, TemplateProcessor } from '../../services/reportTemplateService';
import { toast } from 'react-toastify';
import { AuthContext } from '../../context/auth-context';
import { Description as DescriptionIcon } from '@mui/icons-material';

const TemplateSelector = ({
 selectedOptionShow,
 activeSequence,
 onLoadTemplate,
 onOpenTemplateManager,
 isReady,
 disabled = false,
}) => {
 const [anchorEl, setAnchorEl] = useState(null);
 const [recentTemplates, setRecentTemplates] = useState([]);
 const [loading, setLoading] = useState(false);
 const { user } = useContext(AuthContext);

 const reportType = selectedOptionShow === 'Product' ? 'product_monitoring' : 'brand_monitoring';
 const open = Boolean(anchorEl);
 // const [selectedTemplate, setSelectedTemplate] = useState(null);

 useEffect(() => {
  if (open) {
   loadRecentTemplates();
  }
 }, [open, reportType, user?.user_role?.user_id]);



 const loadRecentTemplates = async () => {
  try {
   setLoading(true);
   const templates = await ReportTemplateService.getTemplates(reportType, user?.user_role?.user_id);
   // Get 5 most recent templates
   setRecentTemplates(templates || []);
  } catch (err) {
   console.error('Failed to load recent templates:', err);
   setRecentTemplates([]);
  } finally {
   setLoading(false);
  }
 };

 const handleMenuOpen = (event) => {
  if (disabled) return; 
  setAnchorEl(event.currentTarget);
 };

 const handleMenuClose = () => {
  setAnchorEl(null);
 };

 

 // const handleLoadTemplate = async (templateId) => {
 //  try {
 //   const { activeSequence: loadedSequence, template } =
 //    await TemplateProcessor.loadTemplate(templateId, user?.user_role?.user_id);

 //   // Find template info from recent templates or use fallback
 //   const templateFromList = recentTemplates.find(t => t.id === templateId);
 //   const templateInfo = {
 //    id: templateId,
 //    name: template?.template_name || templateFromList?.template_name || `Template #${templateId}`,
 //    show_change_data: template?.show_change_data || false,
 //    is_system: template?.is_system || templateFromList?.is_system || false,
 //   };

 //   // Pass both sequence and template info to parent
 //   onLoadTemplate(loadedSequence, templateInfo);

 //   // Remove the old selectedTemplate state management since parent handles it now
 //   handleMenuClose();
 //  } catch (err) {
 //   toast.error('Failed to load template');
 //   console.log(err);

 //  }
 // };

 // const handleQuickSave = async () => {
 //  const templateName = prompt('Enter template name:');
 //  if (!templateName) return;

 //  try {
 //   await TemplateProcessor.saveTemplate({
 //    templateName: templateName.trim(),
 //    description: 'Quick save template',
 //    reportType,
 //    activeSequence,
 //   });
 //   toast.success('Template saved successfully');
 //   handleMenuClose();
 //  } catch (err) {
 //   toast.error(err.message || 'Failed to save template');
 //  }
 // };

 const handleLoadTemplate = async (templateId) => {
  try {
   const { activeSequence: loadedSequence, template } =
    await TemplateProcessor.loadTemplate(templateId, user?.user_role?.user_id);

   // Find template info from recent templates or use fallback
   const templateFromList = recentTemplates.find(t => t.id === templateId);

   // ✅ Pass complete template info including all necessary properties
   const templateInfo = {
    id: templateId,
    name: template?.template_name || templateFromList?.template_name || `Template #${templateId}`,
    description: template?.description || templateFromList?.description,
    show_change_data: template?.show_change_data || false,
    user_id: template?.user_id || templateFromList?.user_id,
    is_system: template?.is_system || templateFromList?.is_system || false,
    can_edit: template?.can_edit ?? templateFromList?.can_edit,
    can_delete: template?.can_delete ?? templateFromList?.can_delete
   };

   // Pass both sequence and template info to parent
   onLoadTemplate(loadedSequence, templateInfo);

   handleMenuClose();
  } catch (err) {
   toast.error('Failed to load template');
   console.log(err);
  }
 };

 const handleQuickSave = () => {
   onOpenTemplateManager?.('save');  // open manager in Save view
   handleMenuClose();
  };


 return (
  <>
   

   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    
      <Button
    variant="outlined"
        size="small"
        onClick={handleMenuOpen}
        endIcon={<ArrowDownIcon />}
        startIcon={<FolderIcon />}
        sx={{ minWidth: 120 }}
     disabled={disabled} 
  >
        Templates
      </Button>
   </Box >

   <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={handleMenuClose}
    PaperProps={{
     sx: { minWidth: 250, maxWidth: 350 }
    }}
   >
    {/* Quick Actions */}
    {/* <MenuItem onClick={handleQuickSave} disabled={!isReady}>
     <ListItemIcon>
      <SaveIcon fontSize="small" />
     </ListItemIcon>
     <ListItemText primary="Quick Save Current" />
    </MenuItem> */}

    <MenuItem onClick={() => { onOpenTemplateManager(); handleMenuClose(); }}>
     <ListItemIcon>
      <SettingsIcon fontSize="small" />
     </ListItemIcon>
     <ListItemText primary="Manage Templates" />
    </MenuItem>

    {recentTemplates.length > 0 && (
     <>
      <Divider />
      {/* <Box sx={{ px: 2, py: 1 }}>
       <Typography variant="caption" color="textSecondary">
        Templates:
       </Typography>
      </Box> */}
      <Box sx={{ px: 2, py: 1, backgroundColor: '#e3f2fd', borderLeft: '3px solid #2196f3' }}>
       <Typography variant="body2" color="primary">
        Select a template below to load its configuration
       </Typography>
      </Box>

      {loading ? (
       <MenuItem disabled>
        <ListItemText primary="Loading..." />
       </MenuItem>
      ) : (
        
         // recentTemplates.map((template, index) => (
         //  <React.Fragment key={template.id}>
         //   <MenuItem
         //    onClick={() => handleLoadTemplate(template.id)}
         //    sx={{
         //     display: 'flex',
         //     flexDirection: 'column',
         //     alignItems: 'flex-start',
         //     py: 1.5,
         //     px: 2
         //    }}
         //   >
         //    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
         //     <DescriptionIcon fontSize="small" color="primary" />
         //     <Typography variant="body2" fontWeight={500} sx={{ flex: 1 }}>
         //      {template.template_name}
         //     </Typography>
         //     {/* <Chip label="Load" size="small" color="primary" variant="outlined" /> */}
         //    </Box>
         //    <Typography variant="caption" color="text.secondary" sx={{ ml: 3.5 }}>
         //     Created: {new Date(template.created_at).toLocaleDateString()}
         //    </Typography>
         //   </MenuItem>
         //   {index < recentTemplates.length - 1 && <Divider />}
         //  </React.Fragment>
         // ))

        <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
         {recentTemplates.map((template, index) => (
          <React.Fragment key={template.id}>
           <MenuItem
            onClick={() => handleLoadTemplate(template.id)}
            sx={{
             display: 'flex',
             flexDirection: 'column',
             alignItems: 'flex-start',
             py: 1.5,
             px: 2
            }}
           >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
             <DescriptionIcon fontSize="small" color="primary" />
             <Typography variant="body2" fontWeight={500} sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {template.template_name}
             </Typography>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ ml: 3.5 }}>
             Created: {new Date(template.created_at).toLocaleDateString()}
            </Typography>
           </MenuItem>
           {index < recentTemplates.length - 1 && <Divider />}
          </React.Fragment>
         ))}
        </Box>
        
      )}
     </>
    )}

    {recentTemplates.length === 0 && !loading && (
     <>
      <Divider />
      <Box sx={{ px: 2, py: 2, textAlign: 'center' }}>
       <Typography variant="body2" color="textSecondary">
        No saved templates yet
       </Typography>
      </Box>
     </>
    )}
   </Menu>
  </>
 );
};

export default TemplateSelector;